export const PASSWORLD_MAP_EMBED_URL =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d177437.28948923957!2d16.72971229453125!3d51.10851500000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc358dc532209%3A0x979a956478cde80f!2sAgencja%20Eventowa%20PassWorld%20Travels%26Events!5e1!3m2!1spl!2spl!4v1771504564091!5m2!1spl!2spl";

export const PASSWORLD_MAP_TITLE = "Mapa - PassWorld Travels & Events Wrocław";
